import { useParams } from "react-router-dom";
import Contact from "@swivu/entity-detail/src/detail-components/Contact.js";

const ContactDetailPublic = () => {
  const { contact_id, slug } = useParams<{
    contact_id: string;
    slug: string;
  }>();
  return (
    <Contact.Provider
      baseUrl={{
        resources: `/schedule/${slug}/resource/`,
        tasks: `/schedule/${slug}/task/`
        // users: `/schedule/${slug}/user/`,
        // clients: `/schedule/${slug}/client/`
      }}
      id={contact_id!}
      api={"public"}
      slug={slug!}
    >
      <Contact />
    </Contact.Provider>
  );
};

export default ContactDetailPublic;
